import React, { Component } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, CustomInput } from "reactstrap";
import { ModalStyles } from "components/Common/styles.js";
import { CRUDFunction } from "reduxCURD/container";
import { loadAllImgs, uploadImgs } from "reduxRelated/actions/imgsUpload.js";
import SpinnerLoader from "../SpinnerLoader";
import { getServerEndpoint } from "utils/serverEndpoint";
import "./style.css";
import { languageService } from "../../../Language/language.service";
import { ButtonStyle, CommonModalStyle } from "style/basic/commonControls";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import { ToastService } from "../../../utils/toastify";
const MyButton = (props) => (
  <button className="setPasswordButton" {...props}>
    {props.children}
  </button>
);

class ImageGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: false,
      selectedImg: null,
      imgsList: [],
      uploadImgFilePlaceHolder: languageService("No file chosen"),
      file: null,
      fileToUpload: false,
    };

    this.styles = themeService({
      default: {
        row: {
          fontSize: "12px",
          minHeight: "30px",
          color: "var(--first)",
          padding: "12px 10px 6px 12px",
          borderLeft: "1px solid #e3e9ef",
          borderRight: "1px solid #e3e9ef",
          borderBottom: "1px solid #e3e9ef",
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.05)",
          transitionDuration: "2s",
        },
      },
      retro: {
        row: {
          fontSize: "12px",
          minHeight: "30px",
          color: "var(--second)",
          padding: "12px 10px 6px 12px",
          borderLeft: "1px solid #e3e9ef",
          borderRight: "1px solid #e3e9ef",
          borderBottom: "1px solid #e3e9ef",
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.05)",
          transitionDuration: "2s",
        },
      },
      electric: {
        row: {
          fontSize: "12px",
          minHeight: "30px",
          color: electricColors.second,
          padding: "12px 10px 6px 12px",
          borderLeft: "1px solid #e3e9ef",
          borderRight: "1px solid #e3e9ef",
          borderBottom: "1px solid #e3e9ef",
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.05)",
          transitionDuration: "2s",
        },
      },
    });

    this.handleImgUpload = this.handleImgUpload.bind(this);
    this.handleImageUploadFileButton = this.handleImageUploadFileButton.bind(this);
  }

  componentDidMount() {
    // if (this.props.loadImgPath) {
    //   this.props.loadAllImgs(this.props.loadImgPath);
    // } else {
    //   this.props.loadAllImgs();
    // }
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (nextProps.imgsList !== prevState.imgsList && nextProps.imgsList && nextProps.imgActionType == "IMGS_LOAD_SUCCESS") {
  //     return {
  //       imgsList: nextProps.imgsList,
  //       actionType: nextProps.imgActionType,
  //     };
  //   } else {
  //     return null;
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.imgActionType == "IMG_UPLOAD_SUCCESS" && this.props.imgActionType !== prevProps.imgActionType && this.state.file) {
      ToastService.Success(languageService("Image uploaded successfully"));
      this.setState({
        selectedImg: this.state.file.name ? this.state.file.name : null,
        loader: false,
        file: null,
        fileToUpload: false,
      });
      if (this.props.loadImgPath) {
        this.props.loadAllImgs(this.props.loadImgPath);
      } else {
        this.props.loadAllImgs();
      }
    }
    if (this.props.imgActionType != prevProps.imgActionType && this.props.imgActionType === "IMG_UPLOAD_FAILURE") {
      this.setState({
        loader: false,
      });
      ToastService.Error("Upload failed: Only image files are allowed.", "");
    }
  }

  // setSelectedImg(img) {
  //   this.setState({
  //     selectedImg: img,
  //   });
  // }

  handleImgUpload(e) {
    let file = e.target.files[0];
    console.log(file);
    if (file) {
      this.setState({
        uploadImgFilePlaceHolder: file.name,
        file: file,
        fileToUpload: true,
      });
    }
  }

  handleImageUploadFileButton() {
    if (this.state.fileToUpload && this.state.file) {
      this.setState({
        loader: true,
      });
      this.props.uploadImgs(this.state.file, this.props.uploadCustomPath ? this.props.uploadCustomPath : null);
    }
  }

  render() {
    // let imgComp, paths;
    // imgComp = null;
    // if (this.state.imgsList) {
    //   imgComp = this.state.imgsList.map((imgName, index) => {
    //     paths = this.props.customFolder
    //       ? getServerEndpoint() + this.props.customFolder + "/" + imgName
    //       : getServerEndpoint() + "thumbnails/" + imgName;
    //     //  console.log(paths)
    //     return (
    //       <div className="colsImgs" key={imgName}>
    //         <img
    //           src={paths}
    //           style={{ display: "block", marginLeft: "auto", marginRight: "auto" }}
    //           alt={imgName}
    //           onClick={(e) => {
    //             this.setSelectedImg(imgName);
    //           }}
    //         />
    //       </div>
    //     );
    //   });
    // }
    return (
      <div className={localStorage.getItem("theme")}>
        <ModalHeader style={(ModalStyles.modalTitleStyle, themeService(CommonModalStyle.header))}>
          {languageService("Select Image")}
        </ModalHeader>

        <ModalBody
          style={
            (ModalStyles.footerButtonsContainer, { ...themeService(CommonModalStyle.footer), display: "block", border: "1px solid #ccc" })
          }
        >
          <SpinnerLoader spinnerLoading={this.state.loader} />

          {this.props.uploadImageAllow && (
            <div>
              <label className="fullWidth">{languageService("Upload Image")}</label>
              <Row>
                <Col md={8}>
                  <div className="fileinputs">
                    <div>
                      <input
                        type="file"
                        id="imgUpload"
                        name="imgFile"
                        label={this.state.uploadImgFilePlaceHolder}
                        onChange={this.handleImgUpload}
                        accept="image/*"
                        style={{
                          width: "100%",
                          border: "1px solid #ccc",
                          paddingLeft: "33px",
                          background: "transparent",
                          color: "rgba(0, 0, 0, 0)",
                        }}
                      />
                    </div>

                    <div className="fakefile" style={{ pointerEvents: "none" }}>
                      <input
                        style={{
                          width: "0px",
                          backgroundColor: "var(--nine)",
                          border: "none",
                          height: " 40px",
                          // borderRight: "1px solid #ccc",
                        }}
                      />
                      <label className="upload-file" style={{ pointerEvents: "none" }}>
                        {languageService("Choose File")}
                      </label>

                      <label className="upload-file-info">{this.state.uploadImgFilePlaceHolder}</label>
                    </div>
                  </div>
                </Col>
                <Col md={2}>
                  <MyButton
                    onClick={this.handleImageUploadFileButton}
                    style={{ height: "40px", width: "60px", ...themeService(ButtonStyle.commonButton), minWidth: "134px" }}
                  >
                    {languageService("Upload")}
                  </MyButton>
                </Col>
              </Row>
            </div>
          )}
          <div>
            <label className="fullWidth">{languageService("Selected Image")}</label>
            <div style={this.styles.row} onClick={this.handleUnitsAddView}>
              {this.state.selectedImg}
            </div>
          </div>
          {/* <div className="rowsOfImgs form-wrapper scrollbarHor">{imgComp}</div> */}
        </ModalBody>
        <ModalFooter style={(ModalStyles.footerButtonsContainer, themeService(CommonModalStyle.footer))}>
          <MyButton
            onClick={(e) => {
              this.props.handleSave(this.state.selectedImg);
            }}
            style={themeService(ButtonStyle.commonButton)}
          >
            {languageService("Select")}
          </MyButton>
          <MyButton onClick={this.props.handleCancel} style={themeService(ButtonStyle.commonButton)}>
            {languageService("Cancel")}{" "}
          </MyButton>
        </ModalFooter>
      </div>
    );
  }
}

let actionOptions = {
  create: false,
  update: false,
  read: false,
  delete: false,
  others: { loadAllImgs, uploadImgs },
};
let variableList = {
  imgReducer: {
    imgsList: [],
  },
};
const ImageGalleryContainer = CRUDFunction(ImageGallery, "imageGallery", actionOptions, variableList, ["imgReducer"]);
export default ImageGalleryContainer;



// WEBPACK FOOTER //
// ./src/components/Common/ImageGallery/index.jsx